module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contentWrap"
    }
  }, [_c('div', {
    staticClass: "content left"
  }, [_c('div', {
    staticClass: "left",
    attrs: {
      "id": "content_1block"
    }
  }, [_c('div', {
    staticClass: "response"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "response_block left linkfont"
  }, [_vm._v("Congratulations! You have successfully registered. A validation email has been sent to "), _c('a', {
    attrs: {
      "href": "javascript: void(0)"
    }
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v(", please click the link in your email to activate your account. Thank you.\n          "), _c('p', [_vm._v("If you haven’t received the email , please click "), _c('a', {
    attrs: {
      "href": "javascript: void(0)"
    },
    on: {
      "click": function($event) {
        _vm.ResendMail()
      }
    }
  }, [_vm._v("here")]), _vm._v(" to resend.")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "200px",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('button', {
    staticClass: "button-warning pure-button ",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_vm._v("Back to Home")])])])]), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "response_icon left"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/succesful_icon.png"),
      "width": "42",
      "height": "42",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-08c8605a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/RegisterResult.vue
// module id = 100
// module chunks = 1